import groq from 'groq'

import { mediaAsset } from '../../../projections/mediaAsset'

function getTotal() {
	return groq`count(*[_type == 'page.article'])`
}

function getAllCategories() {
	return groq`
    *[_type == "category"]{
        "slug": slug.current,
        name,
        subtitle,
        "count": count(*[_type == 'page.article' && references(^._id) && !(_id in path("drafts.**"))]),
        "articles": *[_type == 'page.article' && references(^._id) && !(_id in path("drafts.**"))] | order(sections[0].date desc){
            metadata{
                "slug": slug.current,
                title
            },
            articleSetup{
                date,
                "category": category->name,
                "categorySlug": category->slug.current
            },
            presentation{
                media[0]{...${mediaAsset()}}
            },
            "readTime": sections[1]{
                "time":round(length(pt::text(content)) / 5 / 180 ),
            }.time,
        }
    }[count > 0] | order(count desc)[0...4]
    `
}

function getCategories() {
	return groq`
    (*[_type == 'page.news'][0].sections[0].categories[]->{
        "slug": slug.current,
        name,
        subtitle,
        "count": count(*[_type == 'page.article' && references(^._id) && !(_id in path("drafts.**"))]),
        "articles": *[_type == 'page.article' && references(^._id) && !(_id in path("drafts.**"))] | order(sections[0].date desc){
            metadata{
                "slug": slug.current,
                title
            },
            articleSetup{
                date,
                "category": category->name,
                "categorySlug": category->slug.current
            },
            presentation{
                media[0]{...${mediaAsset()}}
            },
            "readTime": sections[1]{
                "time":round(length(pt::text(content)) / 5 / 180 ),
            }.time,
        }
    })[count > 0]`
}

export const categorySections = groq`
    _type,
    "totalArticles": ${getTotal()},
    "categories": coalesce(${getCategories()}, ${getAllCategories()}),

`
